import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { queryFnGET } from "api/tanStackQuery/helpers";
import useDebouncedValue from "shared/hooks/useDebouncedValue";

export type Employees = {
  employees: Employee[];
};

export type Employee = {
  employeeId: string;
  displayName: string;
  mail: string;
};

export function useEmployeeSearch(search: string) {
  const [debouncedSearch] = useDebouncedValue(search, 40);

  return useQuery<Employee[]>({
    queryKey: ["Employees", debouncedSearch],
    queryFn: () =>
      queryFnGET<Employee[]>({
        signal: undefined,
        url: `${getBackendUrl()}/employees?search=${encodeURIComponent(debouncedSearch)}`,
      }).then((response) => response ?? []),
    staleTime: 1000 * 60 * 5,
    retry: 2,
    enabled: !!debouncedSearch, // Only run query if debouncedSearch is not empty
  });
}
